export const CLONE_LIMIT = 15;
export const LEAVE_CONFIRMATION = 'Leaving the page will lose unsaved changes.';
